import { useContext } from 'react'
import { uuid } from '@src/lib/uuid'
import { delay } from '@src/utils'
import { SpinnerContext } from './SpinnerContext'

interface SpinnerOptions {
  message?: string;
}

export function useSpinner() {
  const { showSpinner, hideSpinner } = useContext(SpinnerContext)

  async function spinner<TResult>(
    promise: Promise<TResult>,
    { message = '' }: SpinnerOptions = {},
  ) {
    const spinnerId = uuid() as string
    showSpinner({ uid: spinnerId, message })

    try {
      const [result] = await Promise.all([promise, delay(300)])

      return result
    } catch (error) {
      throw error
    } finally {
      hideSpinner(spinnerId)
    }
  }

  return { spinner }
}
